module.exports = __webpack_public_path__ + "img/self-signed-ssl-cert.b0d92ae8.png";